// @flow
import React, {PureComponent} from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import Feedback from '@homeaway/react-feedback';
import type {State as ReduxState} from '../../reducers';
import {media} from '../../utils/breakpoints';
import withLingua from '../withLingua/withLingua';

import type {LinguaProps} from '../withLingua/withLingua';

import './ConnectedFeedback.less';

type StateProps = {
    isMobile: boolean
};

type Props = LinguaProps & StateProps;

export class ConnectedFeedback extends PureComponent<Props> {
    render() {
        const {isMobile, isLinguaLoading} = this.props;
        if (isMobile || isLinguaLoading) {
            return null;
        }
        const {messages} = this.props;
        const lingua = {
            tabText: messages['shared.stabFeedback.tabText'],
            title: messages['shared.stabFeedback.title'],
            reviewLink: messages['shared.stabFeedback.reviewLink'],
            reviewLinkText:
                messages['shared.stabFeedback.lookingToWriteReview'],
            helpLink: messages['shared.stabFeedback.helpLink'],
            helpLinkText: messages['shared.stabFeedback.lookingForSupport'],
            supportLinkText: messages['shared.stabFeedback.leaveComment'],
            externalLinkSrText:
                messages['shared.stabFeedback.externalLinkSrText']
        };
        return (
            <div className="ConnectedFeedback">
                <Feedback tabPosition={'bottom'} lingua={lingua} />
            </div>
        );
    }
}

const mapStateToProps = (state: ReduxState): StateProps => ({
    isMobile: !media(state.viewport.breakpoint, {minWidth: 'SM_MIN'})
});

export default compose(
    connect(mapStateToProps),
    withLingua({
        namespace: 'ui-development/shared',
        category: 'stabFeedback'
    })
)(ConnectedFeedback);
